import type { AccessLevel } from '../types';

type PermissionOverrides = Partial<Record<string, Partial<Record<'create' | 'read' | 'update' | 'delete', boolean>>>>;

// Mirrors the module each API route group is gated behind in
// backend/src/routes/index.ts (`requirePermission(...)`) — keeps the Sidebar
// and route guards honest about what a role can actually reach. An empty
// string means "no module gate" (e.g. the Dashboard, which every
// authenticated user can see regardless of role).
export const ROUTE_MODULE: Record<string, string> = {
  dashboard:  '',
  pos:        'pos',
  calendar:   'appointments',
  invoices:   'invoices',
  clients:    'clients',
  staff:      'staff',
  payroll:    'staff',
  leads:      'leads',
  marketing:  'marketing',
  coupons:    'marketing',
  loyalty:    'marketing',
  membership: 'membership',
  packages:   'membership',
  'package-redemptions': 'membership',
  vouchers:   'membership',
  inventory:  'inventory',
  expenses:   'settings',
  services:   'settings',
  branches:   'settings',
  settings:   'settings',
  reports:    'reports',
  'mobile-home': 'settings',
};

/**
 * `access` is null until `fetchRoleAccess` resolves — treated as permissive
 * so nothing flash-redirects before the role's real access map has loaded.
 */
export function hasModuleAccess(
  access: Record<string, AccessLevel> | null,
  module: string,
  overrides?: PermissionOverrides,
): boolean {
  if (!module) return true;
  const readOverride = overrides?.[module]?.read;
  if (typeof readOverride === 'boolean') return readOverride;
  if (!access) return true;
  return (access[module] ?? 'none') !== 'none';
}
